// Generated by Melange

import * as Buhta_cabinet__Button from "../../../html/Button.js";
import * as Buhta_cabinet__Field from "../../../html/Field.js";
import * as Buhta_cabinet__FileUploader from "../../../molecules/FileUploader.js";
import * as Buhta_cabinet__Form from "../../../../core/Form.js";
import * as Buhta_cabinet__ItemFormConstructor from "../../../molecules/ItemFormConstructor.js";
import * as Buhta_cabinet__Keychain from "../../../../grpc/Keychain.js";
import * as Buhta_cabinet__LoadingSpinner from "../../../atoms/LoadingSpinner.js";
import * as Buhta_cabinet__Panel from "../../../html/Panel.js";
import * as Buhta_cabinet__Route from "../../../../Route.js";
import * as Buhta_cabinet__ToastSender from "../../../../util/ToastSender.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__Bytes from "melange/bytes.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function KeyEdit(Props) {
  let id = Props.id;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match$1[1];
  const func = Buhta_cabinet__Keychain.KeyService.view;
  const match$2 = Buhta_core__GrpcState.useModel((function (param) {
    return Curry._3(func, param, /* [] */ 0, id);
  }), undefined);
  const dispatch = match$2[1];
  const model = match$2[0];
  const partial_arg = match[0];
  const form = Buhta_cabinet__Form.useForm(function (param) {
    return Buhta_cabinet__Keychain.KeyService.update(partial_arg, id, param);
  });
  const nameField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
    return {
      TAG: /* Ok */ 0,
      _0: value
    };
  }));
  const passwordField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
    return {
      TAG: /* Ok */ 0,
      _0: value
    };
  }));
  const fileField = Buhta_cabinet__Form.useField(form, undefined, undefined, (function (value) {
    return {
      TAG: /* Ok */ 0,
      _0: value
    };
  }));
  React.useEffect((function () {
    Curry._2(dispatch, undefined, undefined);
  }), [id]);
  React.useEffect((function () {
    if (typeof model === "string" || model.NAME !== "Data") {
      
    } else {
      Curry._1(nameField.onChange, model.VAL.name);
    }
  }), [model]);
  const onSubmit = function (param) {
    const match = Curry._1(form.validate, undefined);
    if (!match) {
      return Curry._1(dispatchToasts, {
        TAG: /* Add */ 0,
        _0: {
          id: Buhta_core__Toast.generateId(undefined),
          text: "Проверьте введенные данные",
          kind: "warning",
          onClick: (function (param) {
            
          })
        }
      });
    }
    const fieldsToForm_name = nameField.value;
    const fieldsToForm_password = passwordField.value;
    const fieldsToForm = {
      name: fieldsToForm_name,
      p12: Stdlib__Bytes.empty,
      password: fieldsToForm_password
    };
    const __x = Curry._1(form.submit, fieldsToForm);
    $$Promise.get(__x, (function (result) {
      if (result.TAG !== /* Ok */ 0) {
        return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при отправке формы:");
      }
      Buhta_cabinet__Route.navigateTo({
        TAG: /* Admin */ 7,
        _0: {
          TAG: /* Keychain */ 0,
          _0: {
            TAG: /* Keys */ 0,
            _0: {
              TAG: /* View */ 0,
              _0: id
            }
          }
        }
      });
      Curry._1(dispatchToasts, {
        TAG: /* Add */ 0,
        _0: {
          id: Buhta_core__Toast.generateId(undefined),
          text: "Учетные данные успешно обновлены",
          kind: "success",
          onClick: (function (param) {
            
          })
        }
      });
    }));
  };
  if (typeof model === "string") {
    return JsxRuntime.jsx(Buhta_cabinet__LoadingSpinner.make, {
      className: "animate-fadeIn"
    });
  } else if (model.NAME === "Data") {
    return JsxRuntime.jsx("form", {
      children: JsxRuntime.jsx(Buhta_cabinet__Panel.make, {
        title: "",
        leftActions: {
          hd: JsxRuntime.jsx("button", {
            children: JsxRuntime.jsx("img", {
              src: StaticAsset.src("/static/icons/close.svg")
            }),
            onClick: (function (param) {
              Buhta_cabinet__Route.navigateTo({
                TAG: /* Admin */ 7,
                _0: {
                  TAG: /* Keychain */ 0,
                  _0: {
                    TAG: /* Keys */ 0,
                    _0: {
                      TAG: /* View */ 0,
                      _0: id
                    }
                  }
                }
              });
            })
          }),
          tl: /* [] */ 0
        },
        rightActions: {
          hd: JsxRuntime.jsx(Buhta_cabinet__Button.make, {
            size: "s",
            kind: "default",
            onClick: (function (param) {
              Buhta_cabinet__Route.navigateTo({
                TAG: /* Admin */ 7,
                _0: {
                  TAG: /* Keychain */ 0,
                  _0: {
                    TAG: /* Keys */ 0,
                    _0: {
                      TAG: /* View */ 0,
                      _0: id
                    }
                  }
                }
              });
            }),
            children: "Отмена"
          }),
          tl: {
            hd: JsxRuntime.jsx(Buhta_cabinet__Button.make, {
              size: "s",
              kind: "primary",
              state: form.isSubmitting ? "Loading" : "Default",
              type_: "submit",
              disabled: form.isSubmitting,
              onClick: (function (param) {
                
              }),
              children: "Обновить"
            }),
            tl: /* [] */ 0
          }
        },
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Buhta_components__Text.Label.make, {
              className: "mb-6 text-default-gray",
              children: "Новые данные"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Buhta_cabinet__ItemFormConstructor.SectionItem.make, {
                  name: "Название",
                  value: JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                    placeholder: "Введите название",
                    size: "s",
                    onChange: nameField.onChange,
                    className: "-mt-2 sm:m-0",
                    validatedValue: nameField.valueForDisplay,
                    value: nameField.value
                  }),
                  size: "medium"
                }),
                JsxRuntime.jsx(Buhta_cabinet__ItemFormConstructor.SectionItem.make, {
                  name: "Пароль",
                  value: JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                    placeholder: "Введите пароль",
                    size: "s",
                    onChange: passwordField.onChange,
                    className: "-mt-2 sm:m-0",
                    validatedValue: passwordField.valueForDisplay,
                    value: passwordField.value
                  }),
                  size: "medium"
                }),
                JsxRuntime.jsx(Buhta_cabinet__ItemFormConstructor.SectionItem.make, {
                  name: "Логин",
                  value: JsxRuntime.jsx(Buhta_cabinet__FileUploader.make, {
                    onChange: (function (file) {
                      Curry._1(fileField.onChange, file);
                    })
                  }),
                  size: "medium"
                })
              ],
              className: "flex flex-col space-y-2 sm:grid sm:grid-cols-6 md:grid-cols-8 lg:grid-cols-12 sm:items-center gap-x-4"
            })
          ],
          className: "p-6"
        })
      }),
      className: "flex-1",
      onSubmit: (function (ev) {
        onSubmit(undefined);
        ev.preventDefault();
      })
    });
  } else {
    console.log("grpc error", model.VAL);
    return "Ошибка: " + "TODO: Unwrap grpc error";
  }
}

const make = KeyEdit;

export {
  make,
}
/* Buhta_cabinet__Button Not a pure module */
